<template>
  <div>
    <v-app-bar app color="primary" dark>
      <div class="d-flex align-center">
        <img class="shrink" contain src="img/logo.png" transition="scale-transition" width="120" />
      </div>

      <v-spacer></v-spacer>

      <div class="d-flex align-right">
        <v-avatar
          size="30"
          class="mr-3 mt-1"
          v-if="
            $store.state.user.user && $store.state.user.user.jsonvalue.hasOwnProperty('image_url')
          "
        >
          <img :src="$store.state.user.user.jsonvalue.image_url" />
        </v-avatar>

        <v-toolbar-title class="mr-3 hidden-xs-only">{{
          $store.state.user.user ? $store.state.user.user.userid : ""
        }}</v-toolbar-title>
        <v-btn outlined class="hidden-xs-only" @click="logout">
          <v-icon class="mr-2">mdi-power</v-icon> ออกจากระบบ
        </v-btn>
        <v-btn small fab text class="hidden-sm-and-up" @click="logout">
          <v-icon>mdi-power</v-icon>
        </v-btn>
        <!-- <v-menu bottom left>
          <template v-slot:activator="{ on, attrs }">
            <v-btn small icon v-bind="attrs" v-on="on">
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>

          <v-card>
            <v-list>
              <v-list-item>
                <v-list-item-avatar>
                  <img :src="$store.state.user.user.jsonvalue.image_url" />
                </v-list-item-avatar>

                <v-list-item-content>
                  <v-list-item-title>{{ $store.state.user.user.userid }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>

            <v-divider />
            <v-list>
              <v-list-item>
                <v-list-item-title :key="'logout'" @click="logout"
                  ><v-icon class="mr-2">mdi-power</v-icon> ออกจากระบบ</v-list-item-title
                >
              </v-list-item>
            </v-list>
          </v-card>
        </v-menu> -->
      </div>

      <template v-slot:extension>
        <v-tabs v-model="tab" centered align-with-title>
          <v-tabs-slider color="yellow"></v-tabs-slider>
          <v-tab to="/summary">
            รายงานผลประกอบการ
          </v-tab>
          <v-tab to="/products">
            สินค้า
          </v-tab>
          <v-tab to="/orders">
            สรุปออเดอร์
          </v-tab>
        </v-tabs>
      </template>
    </v-app-bar>

    <v-main>
      <slot></slot>
    </v-main>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tab: "product",
    };
  },
  methods: {
    async logout() {
      var result = await this.$swal.fire({
        icon: "info",
        title: "ต้องการออกจากระบบใช่หรือไม่?",
        showCancelButton: true,
      });
      if (result.value) {
        this.$store.commit("LOGOUT");
        this.$router.push({
          name: "Login",
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
